var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "sankey-v2",
    {
      attrs: {
        data: _vm.chartData,
        types: _vm.chartTypes,
        "is-loading": _vm.isLoading,
        "highlight-mode": _vm.highlightMode,
        "selected-brick-id": _vm.selectedBrickId,
        "tag-route-type": _vm.tagRouteType
      },
      on: {
        "update:selectedBrickId": function($event) {
          _vm.selectedBrickId = $event
        },
        "update:selected-brick-id": function($event) {
          _vm.selectedBrickId = $event
        }
      }
    },
    [
      _vm.displayTouchpointInfo
        ? _c("touch-point-info", {
            ref: "touchpointInfo",
            staticClass: "touchpoint-info",
            on: {
              close: function($event) {
                _vm.selectedBrickId = null
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }